"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = Notifications;
var _react = _interopRequireWildcard(require("react"));
var _logrocket = _interopRequireDefault(require("logrocket"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _TrackUnmuteModal = require("./TrackUnmuteModal");
var _AutoplayBlockedModal = require("./AutoplayBlockedModal");
var _InitErrorModal = require("./InitErrorModal");
var _TrackBulkUnmuteModal = require("./TrackBulkUnmuteModal");
var _ToastManager = require("../Toast/ToastManager");
var _TrackNotifications = require("./TrackNotifications");
var _PeerNotifications = require("./PeerNotifications");
var _ReconnectNotifications = require("./ReconnectNotifications");
var _ToastBatcher = require("../Toast/ToastBatcher");
var _PermissionErrorModal = require("./PermissionErrorModal");
var _MessageNotifications = require("./MessageNotifications");
var _useUISettings = require("../AppData/useUISettings");
var _useNavigation = require("../hooks/useNavigation");
var _utils = require("../../common/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable no-case-declarations */

function Notifications() {
  var notification = (0, _reactSdk.useHMSNotifications)();
  var navigate = (0, _useNavigation.useNavigation)();
  var HLS_VIEWER_ROLE = (0, _useUISettings.useHLSViewerRole)();
  var subscribedNotifications = (0, _useUISettings.useSubscribedNotifications)() || {};
  var isHeadless = (0, _useUISettings.useIsHeadless)();
  (0, _react.useEffect)(function () {
    var _notification$data, _notification$data2, _notification$data3, _notification$data7, _notification$data8, _notification$data9, _notification$data10, _notification$data11, _notification$data12, _notification$data13, _notification$data14;
    if (!notification) {
      return;
    }
    switch (notification.type) {
      case _reactSdk.HMSNotificationTypes.METADATA_UPDATED:
        // Don't toast message when metadata is updated and raiseHand is false.
        // Don't toast message in case of local peer.
        var metadata = (0, _utils.getMetadata)((_notification$data = notification.data) === null || _notification$data === void 0 ? void 0 : _notification$data.metadata);
        if (!(metadata !== null && metadata !== void 0 && metadata.isHandRaised) || notification.data.isLocal || isHeadless) return;
        console.debug("Metadata updated", notification.data);
        if (!subscribedNotifications.METADATA_UPDATED) return;
        _ToastBatcher.ToastBatcher.showToast({
          notification: notification
        });
        break;
      case _reactSdk.HMSNotificationTypes.NAME_UPDATED:
        console.log(notification.data.id + " changed their name to " + notification.data.name);
        break;
      case _reactSdk.HMSNotificationTypes.ERROR:
        if ((_notification$data2 = notification.data) !== null && _notification$data2 !== void 0 && _notification$data2.isTerminal && ((_notification$data3 = notification.data) === null || _notification$data3 === void 0 ? void 0 : _notification$data3.action) !== "INIT") {
          var _notification$data4;
          if ([500, 6008].includes((_notification$data4 = notification.data) === null || _notification$data4 === void 0 ? void 0 : _notification$data4.code)) {
            var _notification$data5;
            _ToastManager.ToastManager.addToast({
              title: "Error: ".concat((_notification$data5 = notification.data) === null || _notification$data5 === void 0 ? void 0 : _notification$data5.message)
            });
          } else {
            var _notification$data6;
            _logrocket["default"].track("Disconnected");
            // show button action when the error is terminal
            var toastId = _ToastManager.ToastManager.addToast({
              title: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
                justify: "between",
                css: {
                  w: "100%"
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                  css: {
                    mr: "$4"
                  },
                  children: ((_notification$data6 = notification.data) === null || _notification$data6 === void 0 ? void 0 : _notification$data6.message) || "We couldn’t reconnect you. When you’re back online, try joining the room."
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
                  variant: "primary",
                  css: {
                    mr: "$4"
                  },
                  onClick: function onClick() {
                    _ToastManager.ToastManager.removeToast(toastId);
                    window.location.reload();
                  },
                  children: "Rejoin"
                })]
              }),
              close: false
            });
          }
          // goto leave for terminal if any action is not performed within 2secs
          // if network is still unavailable going to preview will throw an error
          setTimeout(function () {
            var previewLocation = window.location.pathname.replace("meeting", "leave");
            _ToastManager.ToastManager.clearAllToast();
            navigate(previewLocation);
          }, 2000);
          return;
        }
        // Autoplay error or user denied screen share(cancelled browser pop-up)
        if (((_notification$data7 = notification.data) === null || _notification$data7 === void 0 ? void 0 : _notification$data7.code) === 3008 || ((_notification$data8 = notification.data) === null || _notification$data8 === void 0 ? void 0 : _notification$data8.code) === 3001 || ((_notification$data9 = notification.data) === null || _notification$data9 === void 0 ? void 0 : _notification$data9.code) === 3011) {
          return;
        }
        if (((_notification$data10 = notification.data) === null || _notification$data10 === void 0 ? void 0 : _notification$data10.action) === "INIT") {
          return;
        }
        if (!subscribedNotifications.ERROR) return;
        _ToastManager.ToastManager.addToast({
          title: "Error: ".concat((_notification$data11 = notification.data) === null || _notification$data11 === void 0 ? void 0 : _notification$data11.message, " - ").concat((_notification$data12 = notification.data) === null || _notification$data12 === void 0 ? void 0 : _notification$data12.description)
        });
        break;
      case _reactSdk.HMSNotificationTypes.ROLE_UPDATED:
        if (notification.data.roleName === HLS_VIEWER_ROLE) {
          return;
        }
        if ((_notification$data13 = notification.data) !== null && _notification$data13 !== void 0 && _notification$data13.isLocal) {
          _ToastManager.ToastManager.addToast({
            title: "You are now a ".concat(notification.data.roleName)
          });
        }
        break;
      case _reactSdk.HMSNotificationTypes.CHANGE_TRACK_STATE_REQUEST:
        var track = (_notification$data14 = notification.data) === null || _notification$data14 === void 0 ? void 0 : _notification$data14.track;
        if (!notification.data.enabled) {
          var _notification$data$re;
          _ToastManager.ToastManager.addToast({
            title: "Your ".concat(track.source, " ").concat(track.type, " was muted by\n                ").concat((_notification$data$re = notification.data.requestedBy) === null || _notification$data$re === void 0 ? void 0 : _notification$data$re.name, ".")
          });
        }
        break;
      case _reactSdk.HMSNotificationTypes.REMOVED_FROM_ROOM:
      case _reactSdk.HMSNotificationTypes.ROOM_ENDED:
        _ToastManager.ToastManager.addToast({
          title: "".concat(notification.message, ". \n              ").concat(notification.data.reason && "Reason: ".concat(notification.data.reason))
        });
        setTimeout(function () {
          var leaveLocation = window.location.pathname.replace("meeting", "leave");
          navigate(leaveLocation);
        }, 2000);
        break;
      case _reactSdk.HMSNotificationTypes.DEVICE_CHANGE_UPDATE:
        _ToastManager.ToastManager.addToast({
          title: notification.message
        });
        break;
      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification, subscribedNotifications.ERROR, subscribedNotifications.METADATA_UPDATED, HLS_VIEWER_ROLE]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!isHeadless && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TrackUnmuteModal.TrackUnmuteModal, {}), !isHeadless && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TrackBulkUnmuteModal.TrackBulkUnmuteModal, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TrackNotifications.TrackNotifications, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PeerNotifications.PeerNotifications, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReconnectNotifications.ReconnectNotifications, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AutoplayBlockedModal.AutoplayBlockedModal, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PermissionErrorModal.PermissionErrorModal, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageNotifications.MessageNotifications, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InitErrorModal.InitErrorModal, {
      notification: notification
    })]
  });
}